import {BaseElement} from "../../../../interfaces/BaseElement";
import {menuHandler} from "../../../menu";

export class BackButton {
    #rootElement;

    constructor(parentElement) {
        this.#rootElement = new BaseElement('button')
            .addClass('mobile-search__back-button', 'icon-left1')
            .event('click', this.#handler)
            .appendTo(parentElement.DOMElement)
    }

    remove() {
        this.#rootElement.remove();
        this.#rootElement = null;
    }

    #handler() {
        menuHandler({target:{dataset:{menuItem:'3dModel'}}});
    }
}